import React, { lazy } from 'react';

const DriversLicenseComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-drivers-license-ds" */ './drivers-license')
);

export const DriversLicenseRoute = () => {
  return <DriversLicenseComponent />;
};
